export const KEYCLOAK_FMS_INFO_KEY = "keyloak.role.info";
export const KEYCLOAK_NO_RESOURCE_ROLE = "keycloak.no-role";
